/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.3
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Soft UI Dashboard PRO React Base Styles
import colors from "assets/theme/base/colors";
import typography from "assets/theme/base/typography";

const { info, dark } = colors;
const { fontFamily, fontWeightRegular } = typography;

const dropdownFontRule = {
  fontFamily: `${fontFamily} !important`,
  fontWeight: `${fontWeightRegular} !important`,
  letterSpacing: "0 !important",
};

const globals = {
  html: {
    scrollBehavior: "smooth",
  },
  body: {
    fontFamily,
    fontSize: "0.875rem",
    fontWeight: fontWeightRegular,
    letterSpacing: 0,
    WebkitFontSmoothing: "antialiased",
    MozOsxFontSmoothing: "grayscale",
  },
  "button, input, textarea, select, option": {
    fontFamily: `${fontFamily} !important`,
  },
  "*, *::before, *::after": {
    margin: 0,
    padding: 0,
    boxSizing: "border-box",
  },
  ".MuiTypography-root, .MuiButtonBase-root, .MuiInputBase-root, .MuiTableCell-root": {
    fontFamily: `${fontFamily} !important`,
    letterSpacing: "0 !important",
  },
  ".MuiDialog-root, .MuiModal-root, .MuiPopover-root, .MuiMenu-root, .MuiPopper-root, .MuiTooltip-popper": {
    fontFamily: `${fontFamily} !important`,
  },
  ".MuiInputBase-root": {
    minHeight: "2.5rem",
    fontSize: "0.875rem !important",
  },
  ".MuiInputBase-input": {
    fontSize: "0.875rem !important",
  },
  ".MuiMenuItem-root": {
    minHeight: "2.25rem",
    fontSize: "0.875rem !important",
    ...dropdownFontRule,
  },
  "[class*='-control'], [class*='-ValueContainer'], [class*='-singleValue'], [class*='-placeholder'], [class*='-Input'], [class*='-input'], [class*='-menu'], [class*='-menuList'], [class*='-option'], [class*='-multiValue'], [class*='-multiValue__label'], .select__control, .select__value-container, .select__single-value, .select__placeholder, .select__input-container, .select__menu, .select__menu-list, .select__option, .select__multi-value, .select__multi-value__label":
    dropdownFontRule,
  ".MuiSelect-select, .MuiNativeSelect-select, .MuiAutocomplete-option, .MuiAutocomplete-listbox, .MuiAutocomplete-popper, .MuiAutocomplete-noOptions, .MuiAutocomplete-loading":
    dropdownFontRule,
  ".MuiTableCell-root": {
    fontSize: "12px",
    fontWeight: 400,
    lineHeight: "1.15 !important",
    textTransform: "none",
  },
  ".MuiTableBody-root .MuiTableCell-root": {
    fontSize: "12px !important",
    lineHeight: "1.15 !important",
  },
  ".MuiTableHead-root .MuiTableCell-root": {
    fontSize: "12px",
    fontWeight: 400,
    textTransform: "capitalize",
  },
  ".MuiTableCell-root .MuiTypography-root": {
    fontSize: "12px !important",
    fontWeight: "400 !important",
    lineHeight: "1.15 !important",
    textTransform: "none",
  },
  ".MuiTableHead-root .MuiTableCell-root .MuiTypography-root": {
    fontSize: "12px",
    fontWeight: "400 !important",
    textTransform: "capitalize",
  },
  "table th": {
    fontSize: "12px",
    fontWeight: 400,
    textTransform: "capitalize",
  },
  "table td": {
    fontSize: "12px !important",
    fontWeight: 400,
    lineHeight: "1.15 !important",
    textTransform: "none",
  },
  ".MuiCard-root": {
    overflow: "hidden",
  },
  "a, a:link, a:visited": {
    textDecoration: "none !important",
  },
  "a.link, .link, a.link:link, .link:link, a.link:visited, .link:visited": {
    color: `${dark.main} !important`,
    transition: "color 150ms ease-in !important",
  },
  "a.link:hover, .link:hover, a.link:focus, .link:focus": {
    color: `${info.main} !important`,
  },
};

export default globals;
